module.exports = __webpack_public_path__ + "img/atheva-logo-header.857fea2c.svg";